<script setup>
import { NConfigProvider, NMessageProvider, NLoadingBarProvider, NDialogProvider, zhCN } from 'naive-ui'
</script>

<template>
  <n-config-provider :locale="zhCN">
    <n-loading-bar-provider>
      <n-dialog-provider>
        <n-message-provider>
          <router-view />
        </n-message-provider>
      </n-dialog-provider>
    </n-loading-bar-provider>
  </n-config-provider>
</template>

<style lang="scss">
body {
  margin: 0;
}

img {
  display: initial !important;
}

.n-button {
  background-color: var(--n-color) !important;
}

.el-button {
  font-weight: normal !important;
}

.el-loading-mask {
  z-index: 999 !important;
}

.v-binder-follower-container {
  z-index: 9999 !important;
}
</style>
